import { faqData } from "../data/mock";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../components/ui/accordion";
import { HelpCircle } from "lucide-react";

export const FAQSection = () => {
  return (
    <section
      id="faq"
      className="relative w-full"
      style={{
        background: "#0F1225",
        padding: "120px 7.6923%",
        borderTop: "1px solid rgba(123,104,238,0.06)",
      }}
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          {/* Left - Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-4"
          >
            <div className="lg:sticky lg:top-[120px]">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-8 h-[2px] rounded-full" style={{ background: "#7B68EE" }} />
                <span
                  className="text-sm tracking-widest uppercase"
                  style={{ color: "#7B68EE", fontFamily: "'Kode Mono', monospace" }}
                >
                  FAQ
                </span>
              </div>

              <h2
                style={{
                  fontFamily: "'Kode Mono', monospace",
                  fontWeight: 600,
                  fontSize: "clamp(28px, 3.5vw, 42px)",
                  color: "#F0F0FF",
                  letterSpacing: "-0.02em",
                  lineHeight: 1.15,
                  marginBottom: "20px",
                }}
              >
                Frequently Asked Questions
              </h2>

              <p
                style={{
                  fontFamily: "'Kode Mono', monospace",
                  fontSize: "15px",
                  color: "#8585A8",
                  lineHeight: 1.7,
                  marginBottom: "32px",
                }}
              >
                Everything you need to know about working with us. Can't find
                what you're looking for? Reach out to our team.
              </p>

              <button
                onClick={() => {
                  const el = document.querySelector("#contact");
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-flex items-center gap-3 cursor-pointer rounded-lg"
                style={{
                  background: "rgba(123,104,238,0.1)",
                  color: "#C4B5FD",
                  padding: "12px 22px",
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: "'Kode Mono', monospace",
                  border: "1px solid rgba(123,104,238,0.2)",
                  transition: "background 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(123,104,238,0.18)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(123,104,238,0.1)";
                }}
              >
                <HelpCircle size={16} />
                Ask Us Directly
              </button>
            </div>
          </motion.div>

          {/* Right - Accordion */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="lg:col-span-8"
          >
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((item, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="border-b-0 mb-3"
                >
                  <div
                    className="rounded-xl overflow-hidden"
                    style={{
                      background: "#121530",
                      border: "1px solid rgba(123,104,238,0.08)",
                      transition: "border-color 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = "rgba(123,104,238,0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "rgba(123,104,238,0.08)";
                    }}
                  >
                    <AccordionTrigger
                      className="px-6 py-5 hover:no-underline"
                      style={{
                        fontFamily: "'Kode Mono', monospace",
                        fontSize: "15px",
                        fontWeight: 500,
                        color: "#F0F0FF",
                        lineHeight: 1.4,
                      }}
                    >
                      <span className="flex items-center gap-4 text-left">
                        <span
                          className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-md"
                          style={{
                            background: "rgba(123,104,238,0.1)",
                            fontSize: "11px",
                            fontWeight: 700,
                            color: "#7B68EE",
                            fontFamily: "'Kode Mono', monospace",
                          }}
                        >
                          {String(index + 1).padStart(2, "0")}
                        </span>
                        {item.question}
                      </span>
                    </AccordionTrigger>
                    <AccordionContent
                      className="px-6 pb-5"
                      style={{
                        fontFamily: "'Kode Mono', monospace",
                        fontSize: "14px",
                        color: "#9494B8",
                        lineHeight: 1.8,
                        paddingLeft: "68px",
                      }}
                    >
                      {item.answer}
                    </AccordionContent>
                  </div>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
